import { ComponentConstants, Cylinder, EntityFactory, Events, eventsManager, Hood, Listener, math, SceneConstants } from "@rhinov/savane-js";
import { CustomController } from "../CustomController";
import { ImportModal } from "../ImportModule/ImportModal";
import { IToolGroupWidget, ToolGroupWidget } from "./toolGroupWidget";
import { IToolWidget, ToolWidget } from "./toolWidget";
import { PlanManager, ActionStateEnum, IdleConstruction, RoomType } from "@rhinov/cocos-plan";

export class PlanEditionWidget {

    //#region Properties & Constructor
    static instance: PlanEditionWidget

    parentElement: HTMLElement;
    controller: CustomController;
    toolGroups: IToolGroupWidget[];
    activeToolGroup: IToolGroupWidget | null = null;
    activeTool: IToolWidget | null = null;
    deliverable: any;
    windowListeners: Record<string, (...args: any[]) => any> = {};
    savaneCancelListener: Listener | null = null;
    savaneUnselectListener: Listener | null = null;
    savaneSelectToolGroupListener: Listener | null = null;
    savaneResizePlanListener: Listener | null = null;
    savanePlanStateChangeListener: Listener | null = null;

    constructor(parentElement: HTMLElement, deliverable: any, realPropertyId: number, userData: { customers_groups_id: number; }) {
        this.parentElement = parentElement;
        this.deliverable = deliverable;
        this.controller = new CustomController();
        this.toolGroups = [

            // Menu Plan Papier
            new ToolGroupWidget("planTools", "Plan papier", "icon-EditText", [
                new ToolWidget("import", "Importer", "import", "icon-Import"),
            ]),

            // Menu des Pièces
            new ToolGroupWidget("roomTools", "Pièce", "icon-ToolsGroup_Rooms", [
                new ToolWidget("roomSquare", "Pièce", "room", "icon-RoomTool_Square", 34),
                new ToolWidget("roomL", "Pièce en 'L'", "room", "icon-RoomTool_L", 34, "inversed"),
                new ToolWidget("roomLmirrored", "Pièce en 'L' miroir", "room", "icon-RoomTool_L", 34, "inversed flip"),
                new ToolWidget("roomLinvert", "Pièce en 'L' inversé", "room", "icon-RoomTool_L", 34, "flip"),
                new ToolWidget("roomLmirror_invert", "Pièce en 'L' miroir inversé", "room", "icon-RoomTool_L", 34, ""),
                new ToolWidget("area", "Zone d'aménagement", "area", "icon-Edit")
            ]),

            // Menu des Murs
            new ToolGroupWidget("wallsTools", "Murs", "icon-ToolsGroup_Walls", [
                new ToolWidget("wall", "Mur isolé", "wall", "icon-WallTool_Wall", 34),
                new ToolWidget("wall2", "Mur maçonné", "wall", "icon-WallTool_Wall", 20),
                new ToolWidget("divider", "Cloison", "wall", "icon-WallTool_Divider", 7),
                new ToolWidget("TechElm-pole", "Poteau", "techElement", "icon-TechElem_Pole"),
            ]),

            // Menu Menuiseries
            new ToolGroupWidget("joineriesTools", "Menuiseries", "icon-ToolsGroup_Joineries", [
                new ToolWidget("frontDoor", "Porte d'entrée", "joinery", "icon-Joinery_FrontDoor"),
                new ToolWidget("window", "Fenêtre", "joinery", "icon-Joinery_Window"),
                new ToolWidget("frenchdoor", "Porte fenêtre", "joinery", "icon-Joinery_FrenchDoor"),
                new ToolWidget("windowdoor", "Baie vitrée", "joinery", "icon-Joinery_PictureWindow"),
                new ToolWidget("fixedwindow", "Châssis fixe", "joinery", "icon-Joinery_FixedWindow"),
                new ToolWidget("velux", "Vélux", "joinery", "icon-Joinery_Velux", undefined, "", true),
                new ToolWidget("door", "Porte", "joinery", "icon-Joinery_Door"),
                new ToolWidget("opening", "Ouverture", "joinery", "icon-Joinery_Openning"),
                new ToolWidget("closetdoor", "Porte de placard", "joinery", "icon-Joinery_Cupboard"),
                new ToolWidget("canopy", "Verrière", "joinery", "icon-Joinery_Canopy", undefined, "", true),
                new ToolWidget("niche", "Niche", "joinery", "icon-Joinery_Niche"),
                new ToolWidget("garagedoor", "Porte de garage", "joinery", "icon-Joinery_GarageDoor"),
            ]),

            // Menu des Escaliers
            new ToolGroupWidget("staircasesTools", "Escaliers", "icon-ToolsGroup_Stairs", [
                new ToolWidget("straight-staircase", "Droit", "staircase", "icon-Stairs_Straight"),
                new ToolWidget("turning-staircase", "Quart tournant", "staircase", "icon-Stairs_Quarter"),
                new ToolWidget("doubleturn-staircase", "Double tournant", "staircase", "icon-Stairs_DoubleQuarter"),
                new ToolWidget("round-staircase", "Colimaçon", "staircase", "icon-Stairs_Circular"),
            ]),

            // Menu des Elements Techniques
            new ToolGroupWidget("technicalElementsTools", "Eléments techniques", "icon-ToolsGroup_TechElem", [
                new ToolWidget("TechElm-beam", "Poutre", "techElement", "icon-TechElem_Beam"),
                new ToolWidget("TechElm-guardrail", "Garde corps", "techElement", "icon-TechElem_Beam"),
                new ToolWidget("TechElm-frame", "Charpente", "techElement", "icon-TechElem_Frame", undefined, "", true),
                new ToolWidget("TechElm-fireplace", "Cheminée", "techElement", "icon-TechElem_Fireplace"),
                new ToolWidget("TechElm-stove", "Poêle", "techElement", "icon-TehcElem_Stove"),
                new ToolWidget("TechElm-radiator", "Radiateur", "techElement", "icon-TechElem_Radiator"),
                new ToolWidget("TechElm-boiler", "Chaudière", "techElement", "icon-TechElem_Boiler"),
                new ToolWidget("TechElm-airConditioner", "Climatisation", "techElement", "icon-TechElem_AirCon", undefined, "", true),
                new ToolWidget("TechElm-spotLight", "Spot lumière", "techElement", "icon-TechElem_Spotlight"),
                new ToolWidget("TechElm-rosette", "Rosace", "techElement", "icon-TechElem_Rosace"),
                new ToolWidget("TechElm-wallDecoration", "Décoration murale", "techElement", "icon-TechElem_Beam", undefined, "", true),
                new ToolWidget("TechElm-switchBoard", "Tableau électrique", "techElement", "icon-TechElem_SwitchBoard"),
                new ToolWidget("TechElm-waterSource", "Point d'eau", "techElement", "icon-TechElem_Water"),
                new ToolWidget("TechElm-socketTV", "Prise TV", "techElement", "icon-TechElem_TVSocket"),
                new ToolWidget("TechElm-socketSixteen", "Prise 16A", "techElement", "icon-TechElem_Socket16A"),
                new ToolWidget("TechElm-socketThirtyTwo", "Prise 32A", "techElement", "icon-TechElem_Socket32A", undefined, "", true),
                new ToolWidget("TechElm-wardrobe", "Penderie", "techElement", "icon-TechElem_Wardrobe"),
            ]),

            // Menu des Primitives
            new ToolGroupWidget("shapeTools", "Formes géométriques", "icon-ToolsGroup_GeomPrim", [
                new ToolWidget("boxprimitive", "Boîte", "box", "icon-GeomPrim_Square"),
                new ToolWidget("cylinderprimitive", "Cylindre", "cylinder", "icon-GeomPrim_Cylinder"),
                new ToolWidget("ovalprimitive", "Oval", "oval", "icon-GeomPrim_Square"),
                new ToolWidget("triangleprimitive", "Triangle", "triangle", "icon-GeomPrim_Square"),
                new ToolWidget("sphereprimitive", "Sphere", "sphere", "icon-GeomPrim_Cylinder"),
                new ToolWidget("hoodprimitive", "Hotte", "hood", "icon-GeomPrim_Square"),
                new ToolWidget("halfarcprimitive", "Demie-Arche", "halfarc", "icon-GeomPrim_Square"),
            ]),

            // Menu des Commentaires
            new ToolGroupWidget("commentTools", "Commentaires", "icon-bubble21", [
                new ToolWidget("writecomment", "Ecrire", "writecomment", "icon-bubble21"),
            ])
        ];

        this.activeToolGroup = null;
        this.parentElement.innerHTML = this.html();
        this.parentElement.style.textAlign = "center";
        this.resizeHtmlElements();
        this.addSavaneListeners();
        this.addListeners();
        PlanEditionWidget.instance = this;
        ImportModal.init(deliverable, userData, realPropertyId);
    }
    //#endregion

    resizeHtmlElements(): void {
        if (!$('#planEdition')[0]) {
            console.error("Can't find planEdition div for resize !!");
            return;
        }
        let toolBarHeight = $('#planEdition').height();
        if (!toolBarHeight) {
            console.warn("Failed to get height of #planEdition !");
            return;
        }
        toolBarHeight /= 2;
        $('#planToolsGroupsBar').css('height', `${toolBarHeight}px`);

        // Tool Groups
        let toolGroups = document.getElementsByClassName("tools-group");

        for (let i = 0; i < toolGroups.length; i++) {
            const toolGroup = toolGroups[i] as HTMLElement;
            toolGroup.style.height = `${toolBarHeight}px`;
        }

        // Tool Group Icons
        let toolGroupIcons = document.getElementsByClassName("tools-group-icon");

        for (let i = 0; i < toolGroupIcons.length; i++) {
            const toolGroupIcon = toolGroupIcons[i] as HTMLElement;
            toolGroupIcon.style.fontSize = `${toolBarHeight * 0.4}px`;
        }

        //Avoid updating bottom part if not showned
        if (this.activeToolGroup === null) return;

        let subBarHeight = toolBarHeight * 0.8;
        // Tools plan-tool
        let subPlanTools = document.getElementsByClassName('sub-plan-tool');

        for (let i = 0; i < subPlanTools.length; i++) {
            const subPlanTool = subPlanTools[i] as HTMLElement;
            subPlanTool.style.width = `${subBarHeight * 1.8}px`;
        }

        // Tools Icons
        let planToolIcons = document.getElementsByClassName('plan-tool-icon');

        for (let i = 0; i < planToolIcons.length; i++) {
            const planToolIcon = planToolIcons[i] as HTMLElement;
            planToolIcon.style.fontSize = `${subBarHeight * 0.4}px`;
        }

        let subSubPlanTools = document.getElementsByClassName('sub-sub-plan-tool');

        for (let i = 0; i < subSubPlanTools.length; i++) {
            const subSubPlanTool = subSubPlanTools[i] as HTMLElement;
            subSubPlanTool.style.width = `${subBarHeight * 0.7}px`;
        }
    }

    //#region Tool & ToolGroup Finders
    findToolbyID(toolId: string) {
        let tools: IToolWidget[] | null = this.toolGroups.map((group) => {
            let foundTools = group.tools.filter((groupTool) => {
                if (groupTool.id === toolId) return groupTool;
            });

            if (foundTools.length !== 1) return null;
            return foundTools[0];
        }).filter((val => val !== null));
        return tools[0];
    }

    findToolGroupbyID(toolGroupId: string) {
        toolGroupId = toolGroupId.split('%')[0];
        let toolGroup: IToolGroupWidget | null = this.toolGroups.filter((group) => {
            return group.id === toolGroupId;
        })[0];
        return toolGroup;
    }
    //#endregion

    //#region Listeners
    addListeners() {
        let winResize = this.resizeHtmlElements.bind(this);
        this.windowListeners['resize'] = winResize;
        window.addEventListener('resize', winResize);
        if ($("#planEdition")[0]) {
            this.controller.addEventListener('quinta:resizeElement', this.resizeHtmlElements.bind(this), 'planEdition', undefined, true);
        }

        this.toolGroups.forEach((toolGroup) => {
            const groupId = toolGroup.id;
            const tool = document.getElementById(`${groupId}%projectTool`);
            if (tool) {
                this.controller.addEventListener('load', this.resizeHtmlElements.bind(this), `${groupId}%projectTool`);
                this.controller.addEventListener('mousedown', (event) => {
                    let toolGroup = event.currentTarget;
                    PlanEditionWidget.instance.selectToolsGroup(toolGroup.id);
                }, `${groupId}%projectTool`);
            }

            let groupToolElements = document.getElementsByClassName("plan-tool");
            for (let i = 0; i < groupToolElements.length; i++) {
                let id = groupToolElements[i].id;
                this.controller.addEventListener('load', this.resizeHtmlElements.bind(this), id, undefined, true);
            }
        });
    }

    addSavaneListeners() {
        let cancel = ((): void => {
            this.activeTool = null;

            if (this.activeToolGroup) {
                this.removeToolGroupListener(this.activeToolGroup);
            }
            this.updateGroupToolsDisplay();
        }).bind(this);
        this.savaneCancelListener = eventsManager.instance.addListener(Events.CANCEL_CLICK, cancel);

        let unselect = ((): void => { this.unselectTool() }).bind(this);
        this.savaneUnselectListener = eventsManager.instance.addListener(Events.TOOL_UNSELLECT, unselect);

        let selectToolGroupListener = ((event: any): void => {
            // Retieve listener data which will contain selected tool id
            var data = event.userData;

            // Parse all tool groups to find correct selected tool id
            for (var i = 0; i < this.toolGroups.length; i++) {
                if (data === this.toolGroups[i].id) {
                    // Found select group
                    this.selectToolsGroup(this.toolGroups[i].id);
                    break;
                }
            }
        }).bind(this);
        this.savaneSelectToolGroupListener = eventsManager.instance.addListener('select_tool_group', selectToolGroupListener);

        this.savaneResizePlanListener = eventsManager.instance.addListener(Events.RESIZE_PLAN_FRAME, this.resizeHtmlElements.bind(this));

        let planStateChangeListener = ((ev: any): void => {
            // If state is going back to IdleContruction unselect current tool
            if (ev.userData === ActionStateEnum.IdleConstruction) {
                if (this.activeTool !== null) {
                    this.activeTool = null;
                }
            }

            // State goes to draw area state
            if (ev.userData === ActionStateEnum.DrawArea) {
                // CLose current tool group and current tool
                this.activeToolGroup = null;
                this.activeTool = null;

                // Search for draw area menu and open its tool group and tool
                for (var i = 0; i < this.toolGroups.length; i++) {
                    for (var j = 0; j < this.toolGroups[i].tools.length; j++) {
                        if (this.toolGroups[i].tools[j].type === "area") {
                            this.activeToolGroup = this.toolGroups[i];
                            this.activeTool = this.toolGroups[i].tools[j];
                        }
                    }
                }
                this.updateHTML();
            }
        }).bind(this);
        this.savanePlanStateChangeListener = eventsManager.instance.addListener(Events.PLAN_STATE_CHANGED, planStateChangeListener);
    }

    removeSavaneListeners() {
        if (this.savaneCancelListener) eventsManager.instance.removeListener(this.savaneCancelListener);
        if (this.savaneUnselectListener) eventsManager.instance.removeListener(this.savaneUnselectListener);
        if (this.savaneSelectToolGroupListener) eventsManager.instance.removeListener(this.savaneSelectToolGroupListener);
        if (this.savaneResizePlanListener) eventsManager.instance.removeListener(this.savaneResizePlanListener);
        if (this.savanePlanStateChangeListener) eventsManager.instance.removeListener(this.savanePlanStateChangeListener);
    }

    toolGroupListener(toolGroup: IToolGroupWidget) {
        toolGroup.tools.forEach((tool) => {
            const toolId = tool.id;

            const toolElement = document.getElementById(`${toolId}%tool`);
            if (toolElement) {
                this.controller.addEventListener('mousedown', (ev) => {
                    let tool = ev.currentTarget;
                    PlanEditionWidget.instance.selectTool(tool.id);
                }, `${toolId}%tool`);
            }

            const thicknessElement = document.getElementById(`${toolId}%thickness`);
            if (thicknessElement) {
                this.controller.addEventListener('keyup', (event) => {
                    event.keyCode === 13 && PlanEditionWidget.instance.verifyToolThickness(event.currentTarget.id);
                }, `${toolId}%thickness`);

                this.controller.addEventListener('blur', (event) => {
                    PlanEditionWidget.instance.verifyToolThickness(event.currentTarget.id);
                }, `${toolId}%thickness`);

                this.controller.addEventListener('change', (event) => {
                    PlanEditionWidget.instance.changeToolThickness(event.currentTarget.id, Number.parseInt(event.currentTarget.value), true);
                }, `${toolId}%thickness`);
            }

            const lessElement = document.getElementById(`${toolId}%less`);
            if (lessElement) {
                this.controller.addEventListener('mousedown', (event) => {
                    PlanEditionWidget.instance.changeToolThickness(event.currentTarget.id, -1);
                }, `${toolId}%less`);
            }

            const moreElement = document.getElementById(`${toolId}%more`);
            if (moreElement) {
                this.controller.addEventListener('mousedown', (event) => {
                    PlanEditionWidget.instance.changeToolThickness(event.currentTarget.id, 1);
                }, `${toolId}%more`);
            }
        });
    }

    removeToolGroupListener(toolGroup: IToolGroupWidget) {
        toolGroup.tools.forEach((tool) => {
            const toolId = tool.id;

            const toolElement = document.getElementById(`${toolId}%tool`);
            if (toolElement) {
                this.controller.removeEventListener('mousedown', `${toolId}%tool`);
            }

            const thicknessElement = document.getElementById(`${toolId}%thickness`);
            if (thicknessElement) {
                this.controller.removeEventListener('keyup', `${toolId}%thickness`);
                this.controller.removeEventListener('blur', `${toolId}%thickness`);
            }

            const lessElement = document.getElementById(`${toolId}%less`);
            if (lessElement) {
                this.controller.removeEventListener('mousedown', `${toolId}%less`);
            }

            const moreElement = document.getElementById(`${toolId}%more`);
            if (moreElement) {
                this.controller.removeEventListener('mousedown', `${toolId}%more`);
            }
        });
    }
    //#endregion

    //#region Tool Logic
    unselectTool() {
        // Close current plan manager state
        PlanManager.getInstance()._state.dispose();
        // Go to IdleConstruction mode (tools are only displayed at construction step)
        PlanManager.getInstance()._state = new IdleConstruction();
        // Inform cocos than the plan state has changed
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);

        this.activeTool = null;

        if (this.activeToolGroup) {
            this.removeToolGroupListener(this.activeToolGroup);
        }
        this.updateGroupToolsDisplay();
    }

    selectTool(toolId: string) {
        toolId = toolId.split('%')[0];
        let tool = this.findToolbyID(toolId);
        if (!tool) {
            console.error(`Failed to find tool '${toolId}'`);
            return;
        }
        PlanManager.getInstance().updateItemsSelected(null);

        //Maybe other types will be available in the futur ?
        let AvailableInFrontTool = ["joinery"];

        if (PlanManager.getInstance().getAction() === ActionStateEnum.FrontView && AvailableInFrontTool.includes(tool.type) !== true) {
            PlanManager.getInstance().switchToNormalMode(true);
        }

        if (this.activeTool !== null && this.activeTool !== undefined) {

            if (this.activeTool.id === tool.id) {
                // Do Nothing
            } else if (this.activeTool.id !== tool.id) {
                this.activeTool = tool;
            }
        } else {
            // No tool selected.
            this.activeTool = tool;
        }

        if (this.activeToolGroup) {
            this.removeToolGroupListener(this.activeToolGroup);
        }
        this.updateGroupToolsDisplay();

        // Handles the interactions with the new tool type.
        switch (tool.type) {

            // Wall creation, inform cocosplan to create a wall with correct thickness
            case "wall":
                if (!this.activeTool.thickness) {
                    console.error("Can't create wall with an undefined thickness !");
                    return;
                };
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: {
                        entityType: SceneConstants.EntityType.Wall,
                        thickness: this.activeTool.thickness * 10 //Convert to mm
                    }
                });
                break;

            // Room creation, inform cocosplan to create a room with wall thickness and room shape / type
            case "room":
                if (!this.activeTool.thickness) {
                    console.error("Can't create room with an undefined thickness !");
                    return;
                };
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: {
                        entityType: SceneConstants.EntityType.Room,
                        thickness: this.activeTool.thickness * 10, //Convert to mm,
                        roomType: this.extractRoomType(this.activeTool)
                    }
                });
                break;

            // Joinery creation, inform cocosplan to create a joinery with a specific entity created for us by SavaneJS (from a type extracted from the selected tool)
            case "joinery":
                const joineryType = this.extractJoineryType(this.activeTool);
                if (joineryType === undefined) return;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: EntityFactory.getInstance().createJoinery(math.vec3.create(), joineryType, SceneConstants.DefaultShortJoineryLength)
                });
                break;

            // Stair creation, inform cocosplan to create a stair with the type extracted from the seected tool
            case "staircase":
                const staircaseType = this.extractStaircaseType(this.activeTool);
                if (staircaseType === undefined) return;
                var stair = EntityFactory.getInstance().createStaircase(staircaseType);
                var stairPosition = math.vec3.create();
                math.vec3.set(stairPosition, 0, 0, 0);
                stair.position = stairPosition;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: stair
                });
                break;

            // Technical element creation, inform cocosplan to create a tech element with the specs extracted from the selected tool and create for us by SavaneJS
            case "techElement":
                // Get technical element type to create
                var techType = this.extractTechElemType(this.activeTool);
                if (techType === undefined) return;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: EntityFactory.getInstance().createTechnicalElement(techType, SceneConstants.TechElementDefaultLength[techType], SceneConstants.TechElementDefaultWidth[techType], SceneConstants.TechElementDefaultHeight[techType], '0')
                });
                break;

            case "box":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.box, 500);
                geomPrim.width = 500;
                geomPrim.length = 500;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "cylinder":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.cylinder, 500);
                (geomPrim as Cylinder).diameter = 500;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "triangle":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.triangle, 500);
                geomPrim.width = 500;
                geomPrim.length = 500;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "oval":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.oval, 500);
                geomPrim.width = 250;
                geomPrim.length = 500;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "sphere":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.sphere, 500);
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "hood":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.hood, 1500);
                geomPrim.width = 500;
                geomPrim.length = 1000;
                (geomPrim as Hood).topWidth = 300;
                (geomPrim as Hood).topLength = 750;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "halfarc":
                var geomPrim = EntityFactory.getInstance().createGeometryPrimitive(SceneConstants.GeometryPrimitiveType.halfarc, 500);
                geomPrim.width = 500;
                geomPrim.length = 500;
                (geomPrim as any).diameter = 500;
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: geomPrim
                });
                break;

            case "writecomment":
                eventsManager.instance.dispatch(Events.ENTITY_EDITION, {
                    entity: EntityFactory.getInstance().createEmptyComment(-1)
                });
                break;

            // Create area component element
            case "area":
                //Change to create area state
                eventsManager.instance.dispatch(Events.COMPONENT_EDITION, {
                    type: ComponentConstants.ComponentType.Area
                });
                break;

            case "import":
                //Open import modal
                ImportModal.open(
                    function () {
                        eventsManager.instance.dispatch(Events.PLAN_UPLOADED);
                    }
                );
                break;

            default:
                console.warn(`WARNING! You need to add a behaviour for the type '${tool.type}' to do anything !`);
                break;
        }
    }

    selectToolsGroup(groupId: string) {
        groupId = groupId.split('%')[0];
        let group = this.findToolGroupbyID(groupId);
        if (PlanManager.getInstance().getAction() === ActionStateEnum.idleVisualise) return;

        // if (PlanManager.getInstance().getAction() === ActionStateEnum.FrontView) {
        //     PlanManager.getInstance().switchToNormalMode(true);
        // }

        // Otherwise unselect current tool
        if (this.activeTool) {
            this.unselectTool();
        }
        // And unselect plan selection
        PlanManager.getInstance().updateItemsSelected(null);


        if (this.activeToolGroup === null) {
            this.activeToolGroup = group;
            this.activeTool = null;
        } else if (this.activeToolGroup.id !== group.id) {
            // Remove the active class from the previous toolGroup
            let previousToolGroupElem = document.getElementById(`${this.activeToolGroup.id}%projectTool`);
            if (!previousToolGroupElem) throw Error(`Cannot find element linked to previous tool group: ${this.activeToolGroup.id}`);
            previousToolGroupElem.classList.remove('active');

            // Set the new active toolGroup
            this.removeToolGroupListener(this.activeToolGroup);
            this.activeToolGroup = group;
            this.activeTool = null;
        } else {
            this.removeToolGroupListener(this.activeToolGroup);
        }

        // Update HTML elements
        this.updateGroupToolsDisplay();
        this.resizeHtmlElements();

        // Tutorial start
        if (group.id === "wallsTools") {
            eventsManager.instance.dispatch(Events.PLAN_TUTO_START, 2);
        }

        if (group.id === "joineriesTools") {
            eventsManager.instance.dispatch(Events.PLAN_TUTO_START, 22);
        }
    }

    changeToolThickness(toolId: string, inc: number, overwrite?: boolean) {
        toolId = toolId.split("%")[0];
        let tool = this.findToolbyID(toolId);
        if (!tool) {
            console.error(`Couldn't find tool '${toolId}' to change its thickness.`);
            return;
        }

        if(overwrite) tool.thickness = inc || 0;
        else tool.thickness = (tool.thickness || 0) + inc;
        this.verifyToolThickness(tool.id);
    }

    verifyToolThickness(toolId: string) {
        toolId = toolId.split("%")[0];
        let tool = this.findToolbyID(toolId);

        if (!tool) {
            console.error(`Couldn't find tool '${toolId}' to verify its thickness.`);
            return;
        }

        if (tool.thickness === undefined || tool.thickness === null) {
            console.error(`The tool '${toolId}' has an undefined thickness...`);
            return;
        }

        if (tool.thickness > SceneConstants.MaxWallThickness / 10) {
            tool.thickness = SceneConstants.MaxWallThickness / 10;
        }
        else {
            if (tool.thickness < SceneConstants.MinimalWallThickness / 10) {
                tool.thickness = SceneConstants.MinimalWallThickness / 10;
            }
        }
        eventsManager.instance.dispatch(Events.EDIT_TOOL_THICKNESS, {
            thickness: tool.thickness
        });

        const thicknessElement = document.getElementById(toolId + '%thickness');
        if (thicknessElement) {
            (thicknessElement as HTMLInputElement).value = '' + tool.thickness;
        }
    }
    //#endregion

    //#region Savane Converters
    extractTechElemType(tool: IToolWidget | null) {
        if (!tool) return undefined;
        switch (tool.id) {
            case "TechElm-waterSource":
                return SceneConstants.TechnicalElementType.waterSource;
            case "TechElm-radiator":
                return SceneConstants.TechnicalElementType.radiator;
            case "TechElm-airConditioner":
                return SceneConstants.TechnicalElementType.airConditioner;
            case "TechElm-boiler":
                return SceneConstants.TechnicalElementType.boiler;
            case "TechElm-pole":
                return SceneConstants.TechnicalElementType.pole;
            case "TechElm-stove":
                return SceneConstants.TechnicalElementType.stove;
            case "TechElm-fireplace":
                return SceneConstants.TechnicalElementType.fireplace;
            case "TechElm-switchBoard":
                return SceneConstants.TechnicalElementType.switchBoard;
            case "TechElm-socketTV":
                return SceneConstants.TechnicalElementType.socketTV;
            case "TechElm-socketSixteen":
                return SceneConstants.TechnicalElementType.socketSixteen;
            case "TechElm-socketThirtyTwo":
                return SceneConstants.TechnicalElementType.socketThirtyTwo;
            case "TechElm-wardrobe":
                return SceneConstants.TechnicalElementType.wardRobe;
            case "TechElm-spotLight":
                return SceneConstants.TechnicalElementType.spotLight;
            case "TechElm-rosette":
                return SceneConstants.TechnicalElementType.rosette;
            case "TechElm-beam":
                return SceneConstants.TechnicalElementType.beam;
            case "TechElm-guardrail":
                return SceneConstants.TechnicalElementType.guardrail;
            case "TechElm-frame":
                return SceneConstants.TechnicalElementType.frame;
            case "TechElm-wallDecoration":
                return SceneConstants.TechnicalElementType.wallDecoration;
        };
    }

    extractRoomType(tool: IToolWidget | null) {
        if (!tool) return undefined;
        switch (tool.id) {
            case "roomSquare":
                return RoomType.square;
            case "roomL":
                return RoomType.L0;
            case "roomLmirrored":
                return RoomType.L270;
            case "roomLinvert":
                return RoomType.L90;
            case "roomLmirror_invert":
                return RoomType.L180;
        };
    }

    extractJoineryType(tool: IToolWidget | null) {
        if (!tool) return undefined;
        switch (tool.id) {
            case "door":
                return SceneConstants.JoineryType.door;
            case "frontDoor":
                return SceneConstants.JoineryType.frontDoor;
            case "window":
                return SceneConstants.JoineryType.window;
            case "opening":
                return SceneConstants.JoineryType.opening;
            case "frenchdoor":
                return SceneConstants.JoineryType.frenchWindow;
            case "windowdoor":
                return SceneConstants.JoineryType.pictureWindow;
            case "closetdoor":
                return SceneConstants.JoineryType.cupboardDoor;
            case "fixedwindow":
                return SceneConstants.JoineryType.fixedWindow;
            case "velux":
                return SceneConstants.JoineryType.velux;
            case "canopy":
                return SceneConstants.JoineryType.canopy;
            case "garagedoor":
                return SceneConstants.JoineryType.garageDoor;
            case "niche":
                return SceneConstants.JoineryType.niche;
        };
    }

    extractStaircaseType(tool: IToolWidget | null) {
        if (!tool) return undefined;
        switch (tool.id) {
            case "straight-staircase":
                return SceneConstants.StaircaseType.straight;
            case "turning-staircase":
                return SceneConstants.StaircaseType.quarterTurn;
            case "doubleturn-staircase":
                return SceneConstants.StaircaseType.doubleQuarterTurn;
            case "round-staircase":
                return SceneConstants.StaircaseType.circular;
        };
    }
    //#endregion

    //#region Updaters
    updateGroupToolsDisplay() {
        this.updateToolsHTML();
        if (this.activeToolGroup) {
            this.toolGroupListener(this.activeToolGroup);
            let elem = document.getElementById(`${this.activeToolGroup.id}%projectTool`);
            if (!elem) throw Error(`Cannot find element linked to active tool group: ${this.activeToolGroup.id}`);
            if (elem.className.search("active") !== -1) return;
            elem.classList.add('active');
        }
    }

    updateToolsHTML() {
        let container = document.getElementById("flexToolBar");
        if (!container) {
            console.error("Failed to find #flexToolBar !");
            return;
        }

        if (!container.parentElement) {
            console.error("#flexToolBar doesn't have a parentElement !");
            return;
        }
        container.parentElement.style.display = "";
        container.innerHTML = this.getToolGroupToolsHTML();
        this.resizeHtmlElements();
    }

    updateHTML() {
        this.parentElement.innerHTML = this.html();
    }
    //#endregion

    //#region HTML
    html() {
        return `
            <div id="planToolsGroupsBar">
                ${this.getToolGroupsHTML()}
            </div>

            <div id="planToolsBar" ${this.activeToolGroup !== null ? 'style="display:none"' : ''}>
                <div id="flexToolBar">
                    ${this.getToolGroupToolsHTML()}
                </div>
            </div>
        `
    }

    getToolGroupsHTML() {
        let html = ``
        this.toolGroups.forEach((group) => {
            let classes = "tools-group";
            if (this.activeToolGroup !== null && this.activeToolGroup.id === group.id) {
                classes += " active";
            }

            let groupHtml = `
                <div class="${classes}" id="${group.id}%projectTool">
                    <!-- Tool group icon -->
                    ${group.icon ? `<div class="tools-group-icon ${group.icon}"></div>` : ""}

                    <!-- Tool group name -->
                    <div class="tools-group-title">
                        ${group.name}
                    </div>

                    <!-- Separator will act as a underline selection in this case if the tool group is selected -->
                    <div class="separator"></div>
                </div>
            `;
            html += groupHtml;
        });

        return html;
    }

    getToolGroupToolsHTML() {
        if (this.activeToolGroup === null) {
            return "";
        }

        let html = `
            ${this.activeToolGroup.html(this.activeTool)}
        `;
        return html;
    }
    //#endregion

    destroy() {
        // Destroy what is needed.
        this.controller.destroy();
        this.removeSavaneListeners();
        Object.keys(this.windowListeners).forEach((k) => {
            window.removeEventListener(k, this.windowListeners[k]);
        });
        console.log("Finished destroying PlanEditionWidget !");
    }
}